
import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { CachedDataService } from '@services/data/cached-data.service';

/*Models */
import { Track } from '@models/track';

/*Plugins */
import { } from '@types/googlemaps';
import { Geozone, Location } from '@models';




@Injectable()
export class ScreenService {
  map: google.maps.Map;
  markers: google.maps.Marker[] = [];
  tracksInfo = [];
  mapItems = [];
  currentMarker = {
    latitude: null,
    longitude: null
  };
  isStateHidden = true;
  private isMapInitialized: boolean;
  isShowLoader = true;
  circleRadius;
  drawingManager = new google.maps.drawing.DrawingManager();
  private geozone;

  public isDataLoadingSubject: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public isDataLoadingObservable = this.isDataLoadingSubject.asObservable();


  public triggerStateSubject: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public triggerStateObservable = this.triggerStateSubject.asObservable();

  onChangeGeozoneSubject:Subject<Array<Location>> = new Subject<Array<Location>>();
  onChangeGeozoneObservable = this.onChangeGeozoneSubject.asObservable()

  defaultCoordinate = {
    latitude: 55.752390,
    longitude: 37.621224,
  }
  constructor(private cachedDataService: CachedDataService) { }






  initMap(element) {
    if (this.isMapInitialized) {
      return;
    }

    const mapProp = {
      center: new google.maps.LatLng(55.752390, 37.621224),
      zoom: 5,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      mapTypeControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DEFAULT,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      }
    };
    this.map = new google.maps.Map(element, mapProp);
  }

  setCenter(latitude?: number, longitude?: number, zoom?:number) {
    if(!zoom){
      zoom = 14;
    }
    if (!latitude || !longitude) {
      latitude = this.defaultCoordinate.latitude;
      longitude = this.defaultCoordinate.longitude;
      zoom = 5;
    }
    const coordinate = new google.maps.LatLng(latitude, longitude);
    this.map.panTo(coordinate);
    this.map.setZoom(zoom);
  }

  addMarker(latitude: number, longitude: number, content: string, precision) {
    this.currentMarker['latitude'] = latitude;
    this.currentMarker['longitude'] = longitude;
    const coordinate = new google.maps.LatLng(latitude, longitude);
    const marker = new google.maps.Marker({ position: coordinate, title: 'текущее местоположение' });
    const infowindow = new google.maps.InfoWindow({
      content: content
    });
    let click = false;
    marker.addListener('click', () => {
      infowindow.open(this.map, marker);
      click = true;
    });
    marker.addListener('mouseover', () => {
      if (!click) {
        infowindow.open(this.map, marker);
      }
    });
    marker.addListener('mouseout', function () {
      if (!click) {
        infowindow.close();
      }

    });

    google.maps.event.addListener(infowindow, 'closeclick', function () {
      click = false;
    });


    marker.setMap(this.map);
    this.markers.push(marker);

    if (precision) {
      this.hideRadius();
      this.addCircle(latitude, longitude, precision);
    } else {
      this.hideRadius();
    }

  }
  addCircle(latitude: number, longitude: number, precision: number) {
    const currentDevice = this.cachedDataService.getCurrentDevice();
    if (currentDevice.provider === 'magicsystems') {
      precision = precision / 10;
    }

    this.circleRadius = new google.maps.Circle({
      map: this.map,
      radius: precision,
      fillColor: '#FF0000',
      fillOpacity: 0.1,
      strokeColor: '#FF0000',
      strokeOpacity: 0.5,
      strokeWeight: 2,
      center: {
        lat: latitude,
        lng: longitude
      },
    });
    this.circleRadius.setMap(this.map);
  }

  hideRadius() {
    if (this.circleRadius && this.map) {
      this.circleRadius.setMap(null);
      this.circleRadius = null;
    }

  }
  removeMarker() {
    this.hideRadius();
    while (this.markers.length) {
      const marker = this.markers.pop();
      google.maps.event.clearInstanceListeners(marker);
      marker.setMap(null);
    }

  }

  setMarker(latitude: number, longitude: number, content: string, precision: number) {
    this.removeMarker();

    this.addMarker(latitude, longitude, content, precision);
  }

  showSingleTrack(track: Track) {

    this.cleanTracksData();
    this.mapFit(track);
    this.showTrack(track);

    this.showTrackBorders(track.startLatitude, track.startLongitude, track.finishLatitude, track.finishLongitude);
  }

  showTrackBorders(startLat, startLong, finishLat, finishLong) {
    /*show first and finish icon */
    const startImage = {
      url: './assets/images/start.svg',
      size: new google.maps.Size(50, 80),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 70)
    };

    const finishImage = {
      url: './assets/images/finish.svg',
      size: new google.maps.Size(50, 80),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 70)
    };

    const startMarker = new google.maps.Marker({
      position: { lat: startLat, lng: startLong },
      map: this.map,
      icon: startImage
    });

    this.mapItems.push(startMarker);

    const finishMarker = new google.maps.Marker({
      position: { lat: finishLat, lng: finishLong },
      map: this.map,
      icon: finishImage
    });

    this.mapItems.push(finishMarker);
  }

  cleanTracksData() {
    this.mapItems.forEach(element => {
      if (element.setMap) {
        element.setMap(null);
      }
    });

    this.mapItems = [];
  }

  showAllTracks(tracks: Track[]) {
    this.cleanTracksData();
    this.hideRadius();
    if (tracks.length) {

      this.mapFit(tracks);
      const that = this;

      setTimeout(() => {
        tracks.forEach(track => {
          that.showTrack(track);
        });

      }, 300);

      const firstTrack = tracks[0];
      const lastTrack = tracks[tracks.length - 1];

      this.showTrackBorders(firstTrack.startLatitude, firstTrack.startLongitude,
        lastTrack.finishLatitude, lastTrack.finishLongitude);
    }

  }


  mapFit(tracks) {
    let arrayTracks = [];
    let minLat;
    let maxLat;
    let minLng;
    let maxLng;

    if (!Array.isArray(tracks)) {
      arrayTracks.push(tracks);
    } else {
      arrayTracks = tracks;
    }

    arrayTracks.forEach(function (track) {
      track.items.forEach(function (point) {
        if (!minLat || minLat > point.latitude) {
          minLat = point.latitude;
        }
        if (!minLng || minLng > point.longitude) {
          minLng = point.longitude;
        }
        if (!maxLat || maxLat < point.latitude) {
          maxLat = point.latitude;
        }
        if (!maxLng || maxLng < point.longitude) {
          maxLng = point.longitude;
        }
      });
    });
    const k = 0.2;
    minLng -= (maxLng - minLng) * k;
    maxLng += (maxLng - minLng) * k;

    const pointStart = new google.maps.LatLng(minLat, minLng);
    const pointEnd = new google.maps.LatLng(maxLat, maxLng);
    const bounds = new google.maps.LatLngBounds(pointStart, pointEnd);
    this.map.fitBounds(bounds);
    this.map.panBy(-200, 0);
  }




  showTrack(track: Track) {
    this.removeMarker();
    const items = [];
    const arrowPath = [];

    track.items.forEach((point, index, points) => {
      arrowPath.push(new google.maps.LatLng(point.latitude, point.longitude));
      const nextPoint = points[index + 1];
      if (!nextPoint) {
        return;
      }

      const coordStart = new google.maps.LatLng(point.latitude, point.longitude);
      const coordFinish = new google.maps.LatLng(nextPoint.latitude, nextPoint.longitude);
      const path = [coordStart, coordFinish];
      let color1 = 'rgb(60, 223, 32)';
      let color2 = 'rgb(65, 132, 54)';
      if (point.speed) {
        if (point.speed >= 60) {
          color1 = 'rgb(253, 157, 0)';
          color2 = 'rgb(169, 105, 0)';
        }
        if (point.speed > 90) {
          color1 = 'rgb(252, 0, 0)';
          color2 = 'rgb(157, 11, 12)';
        }
      }
      const line1 = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: color1,
        strokeOpacity: 1,
        strokeWeight: 7,
        zIndex: -2 * nextPoint.timestamp
      });

      const line2 = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: color2,
        strokeOpacity: 1,
        strokeWeight: 9,
        zIndex: -999999999999999
      });

      items.push(line1);
      items.push(line2);

      let contentString = '<div>';
      contentString += '<h5 style="margin:5px 0;">Отрезок маршрута</h5>';
      contentString += `<div><b>Время отрезка:</b> <br> ${this.getTime(point.timestamp)} - <br> ${this.getTime(nextPoint.timestamp)} <div>`;
      contentString += `<div><b>Скорость:</b> ${point.speed} км/ч<div>`;
      contentString += '<div>';

      const infoWindow = new google.maps.InfoWindow({
        content: contentString,
        position: coordStart
      });

      this.tracksInfo.push(infoWindow);

      const clickHandler = () => {
        this.tracksInfo.forEach(element => {
          element.close();
        });
        infoWindow.open(this.map);
      };

      line1.addListener('click', clickHandler);
      line2.addListener('click', clickHandler);
    });

    const arrowSymbol = {
      path: 'M -3,0 0,-5 3,0 -0.5,0 -0.5,6 0.5,6 0.5,0 0,0 0,-3 z',
      strokeOpacity: 1,
      strokeColor: 'white',
      strokeWeight: 2,
      scale: 1
    };

    const arrowLine = new google.maps.Polyline({
      icons: [{
        icon: arrowSymbol,
        repeat: '75px',
        offset: '50%'
      }],
      path: arrowPath,
      strokeOpacity: 0,
      clickable: false
    });

    items.push(arrowLine);

    items.forEach(mapItem => {
      this.mapItems.push(mapItem);
      mapItem.setMap(this.map);
    });
  }
  getTime(unix_timestamp) {
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    const date = new Date(unix_timestamp * 1000);
    // Hours part from the timestamp
    const hours = date.getHours();
    // Minutes part from the timestamp
    const minutes = '0' + date.getMinutes();
    // Seconds part from the timestamp
    const seconds = '0' + date.getSeconds();
    const year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let day: any = date.getDate();

    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }

    // Will display time in 10:30:23 format
    const formattedTime = `${hours}:${minutes.substr(-2)}:${seconds.substr(-2)} ${day}.${month}.${year}`;


    return formattedTime;
  }

  public trackGetAddress(startLatitude, startLongitude, cb) {

    this.placeInfo({
      lat: startLatitude,
      lng: startLongitude,
    }, (place) => {
      if (place && place.formatted_address) {
        return cb(place.formatted_address.split(', Россия')[0]);
      }
      cb();
    });
  }

  placeInfo(params, cb) {

    const findPlace = this.cachedDataService.getPlaceInfo({ lat: params.lat, lng: params.lng });
    if (findPlace) {
      return cb(findPlace.place);
    }

    const location = new google.maps.LatLng(params.lat, params.lng);
    const geocoder = new google.maps.Geocoder();
    const that = this;
    geocoder.geocode({ 'location': location }, function (results, status) {
      if (typeof cb !== 'function') {
        return;
      }
      if (status === google.maps.GeocoderStatus.OK) {
        const place = results[0];
        that.cachedDataService.setPlaceInfo({ lat: params.lat, lng: params.lng, place: place });
        return cb(place);
      }
      cb();
    });
  }
  initGeozone(drawingControl: boolean){
    this.drawingManager.setOptions({
      drawingMode : google.maps.drawing.OverlayType.RECTANGLE,
      drawingControl : drawingControl,
      
      drawingControlOptions : {
        position : google.maps.ControlPosition.TOP_LEFT,
        drawingModes : [ google.maps.drawing.OverlayType.RECTANGLE ]
      },
      rectangleOptions : {
        strokeColor : '#23508c',
        strokeWeight : 3.5,
        fillColor : '#013c60',
        fillOpacity : 0.3,
        editable: true,
        draggable: true
      }	
    });

    // Loading the drawing Tool in the Map.
    this.drawingManager.setMap(this.map);

    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event)=> {
     
      if (event.type == google.maps.drawing.OverlayType.RECTANGLE) {

        let newShape = event.overlay;
        newShape.type = event.type;
        this.geozone = newShape;

        var ne = this.geozone.getBounds().getNorthEast();
        var sw = this.geozone.getBounds().getSouthWest();
        let points = [
          {
            latitude: sw.lat(),
            longitude: sw.lng()
          },
          {
            latitude: ne.lat(),
            longitude: ne.lng()
          }
        ]

    this.onChangeGeozoneSubject.next(points);


        this.drawingManager.setDrawingMode(null);
        this.drawingManager.setOptions({
          drawingControl : false,
        })
      }
    });
  }
  showNewGeozone(){
    
    this.initGeozone(true);
    this.clearGeozone();
    this.drawingManager.setOptions({
      drawingControl: true,
      drawingMode: google.maps.drawing.OverlayType.RECTANGLE
    });
   console.log(true)
    // let diff = 0.005;
    // let coordinate = this.defaultCoordinate;
    
    // if(this.currentMarker && this.currentMarker.latitude && this.currentMarker.longitude){
    //   coordinate = this.currentMarker;
    // }
    // let points = [
    //   {
    //     latitude: coordinate.latitude-diff,
    //     longitude: coordinate.longitude-diff
    //   },
    //   {
    //     latitude: coordinate.latitude+diff,
    //     longitude: coordinate.longitude+diff
    //   }
    // ]
    // let bounds = new google.maps.LatLngBounds(
    //   new google.maps.LatLng(points[0].latitude, points[0].longitude),
    //   new google.maps.LatLng(points[1].latitude, points[1].longitude)
    // );
    // this.showRectangleGeozone(bounds, points);
    // this.onChangeGeozoneSubject.next(points);
    
  }

  showGeozone(points: Array<Location>){
    this.initGeozone(false)
    let bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(points[0].latitude, points[0].longitude),
        new google.maps.LatLng(points[1].latitude, points[1].longitude)
    );
    this.showRectangleGeozone(bounds, points); 
  }

  clearGeozone(){
    if(this.geozone){
      this.geozone.setMap(null);
    }
  }
  clearEditableGeozone(){
    this.showNewGeozone();
  }
  showRectangleGeozone(bounds, points: Array<Location>){
   
    this.clearGeozone();

    this.setCenter(points[0].latitude, points[0].longitude)
  
      //Setting options for the Drawing Tool. In our case, enabling Polygon shape.
    this.geozone = new google.maps.Rectangle({
      strokeColor : '#23508c',
        strokeWeight : 3.5,
        fillColor : '#013c60',
        fillOpacity : 0.3,
        bounds: bounds,
        editable: true,
        draggable: true
    });
    
    this.geozone.setMap(this.map);
    this.drawingManager.setDrawingMode(null);

    this.geozone.addListener('bounds_changed', ()=>{
      let points = [
        {
          latitude: this.geozone.getBounds().getSouthWest().lat(),
          longitude: this.geozone.getBounds().getSouthWest().lng()
        },
        {
          latitude: this.geozone.getBounds().getNorthEast().lat(),
          longitude: this.geozone.getBounds().getNorthEast().lng()
        }
      ]
      this.onChangeGeozoneSubject.next(points);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/screen.service.ts